export default __webpack_public_path__ + "static/media/banner-aside.multimedia.c546d0bb.gif";